import React from "react";

//Import Breadcrumb
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";

const RadioButtonGroup = ({ title, error, data, setValue, required, name, value, disabled, flexDirection }) => {
    return (
        <React.Fragment>
            <FormControl variant="standard" fullWidth>
                <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>
                    {title}
                    {required && error && <FormHelperText sx={{ color: "red" }}> Please select an option</FormHelperText>}
                </FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue=""
                    value={value}
                    name={name}
                    style={{ fontFamily: 'Manrope-SemiBold', display: "flex", flexDirection: flexDirection}}
                    onChange={(e) => disabled ? "" : setValue(e.target.value)}

                >
                    {
                        data && data.length > 0 && data.map((x, idx) =>
                            <FormControlLabel value={x.value} key={idx} style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}
                                control={<Radio sx={{
                                    '&.Mui-checked': {
                                        color: "#ED1A3D",
                                    },
                                }} />}
                                label={
                                    <>
                                        <div style={{ fontFamily: 'Manrope', fontSize: 14 }}>{x.label}</div>
                                        <div style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{x.description}</div>
                                    </>
                                }
                            />
                        )
                    }

                </RadioGroup>
                <FormLabel style={{ fontSize: 13, color: '#74788D', marginTop: '5px' }}>{ }</FormLabel>
                {/* {required && error && <FormHelperText> Please select an option</FormHelperText>} */}
            </FormControl>
        </React.Fragment >
    );
};

export default RadioButtonGroup;
